import { TipoNI } from "src/app/sitfis/model/enum/tipo-ni";
import { OrigemPendenciaPessoaFisica, SituacaoFiscalPessoaFisicaDto, TipoNIRequerente } from "src/app/sitfis/model/situacao-fiscal-pf-dto";

export const SITUACAO_FISCAL_PESSOA_FISICA_DTO: SituacaoFiscalPessoaFisicaDto[] = [
  {
    "tipoNI": TipoNI.CPF,
    "pendenciasExistentes": [
      OrigemPendenciaPessoaFisica.ContaCorrente,
      OrigemPendenciaPessoaFisica.ParcsnCobranca,
      OrigemPendenciaPessoaFisica.ParcsnExigibilidade,
      OrigemPendenciaPessoaFisica.SiefDebitoCobranca,
      OrigemPendenciaPessoaFisica.SiefDebitoExigibilidade,
      OrigemPendenciaPessoaFisica.SiefProcessoCobranca,
      OrigemPendenciaPessoaFisica.SiefProcessoExigibilidade,
      OrigemPendenciaPessoaFisica.PgfnInscricaoCobranca,
      OrigemPendenciaPessoaFisica.PgfnInscricaoExigibilidade,
      OrigemPendenciaPessoaFisica.SicobDebitoExigibilidade,
      OrigemPendenciaPessoaFisica.CadPreposto,
      OrigemPendenciaPessoaFisica.CadResp,
      OrigemPendenciaPessoaFisica.CadSocio,
    ],
    "pendenciasNaoExistentes": [
      // Funcionalidades ainda não mockadas
      OrigemPendenciaPessoaFisica.IrregularidadeCadastral,
      OrigemPendenciaPessoaFisica.SiefProcessoArrolamento,
      OrigemPendenciaPessoaFisica.ItrContaCorrente,
      OrigemPendenciaPessoaFisica.SicobDebitoCobranca,
      OrigemPendenciaPessoaFisica.AguiaCobranca,
      OrigemPendenciaPessoaFisica.DividaDebitoCobranca,
      OrigemPendenciaPessoaFisica.CcpfExigibilidade,
      OrigemPendenciaPessoaFisica.CcitrExigibilidade,
      OrigemPendenciaPessoaFisica.DividaDebitoExigibilidade,
      OrigemPendenciaPessoaFisica.ProfiscProcessoCobranca,
      OrigemPendenciaPessoaFisica.ProfiscProcessoExigibilidade,
      OrigemPendenciaPessoaFisica.SipadeParcelamentoCobranca,
      OrigemPendenciaPessoaFisica.PaexParcelamentoCobranca,
      OrigemPendenciaPessoaFisica.SiefparParcelamentoCobranca,
      OrigemPendenciaPessoaFisica.ImpedimentoCertidaoRfb,
      OrigemPendenciaPessoaFisica.ImpedimentoCertidaoPgfn,
      OrigemPendenciaPessoaFisica.SicobParcelamentoCobranca,
      OrigemPendenciaPessoaFisica.PgfnParcelamentoCobranca,
      OrigemPendenciaPessoaFisica.SisparPgfnCobranca,
      OrigemPendenciaPessoaFisica.DividaParcelamentoCobranca,
      OrigemPendenciaPessoaFisica.SipadeParcelamentoExigibilidade,
      OrigemPendenciaPessoaFisica.PaexParcelamentoExigibilidade,
      OrigemPendenciaPessoaFisica.SiefparParcelamentoExigibilidade,
      OrigemPendenciaPessoaFisica.SicobParcelamentoExigibilidade,
      OrigemPendenciaPessoaFisica.PgfnParcelamentoExigibilidade,
      OrigemPendenciaPessoaFisica.SisparPgfnExigibilidade,
      OrigemPendenciaPessoaFisica.DividaParcelamentoExigibilidade,
      OrigemPendenciaPessoaFisica.DirpfAusencia,
      OrigemPendenciaPessoaFisica.DitrAusencia,
      OrigemPendenciaPessoaFisica.GfipAusencia,
    ],
    "pendenciasNaoAnalisadas": [],
    "pendenciasIndisponiveis": [],
    "pendenciasEmProcessamento": [],
    "ni": "85122220425",
    "dataEvento": null,
    "certidaoNumeroControle": "",
    "certidaoDataValidade": null,
    "certidaoDataEmissao": null,
    "tipoCertidao": null,
    "numeroLiberacao": "0000000000",
    "indicadorUsoLiberacao": 0,
    "indicadorEnteFederativoPrincipal": 0,
    "indicadorVinculado": 1,
    "tipoNIRequerente": TipoNIRequerente.CPFAtivo
  }
]